import { Component, OnInit } from "@angular/core";
import { BaseService } from "src/app/Services/Base.service";
import { Router } from "@angular/router";
declare var $: any;

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss"]
})
export class NavComponent implements OnInit {
  lang: string;

  constructor(private base: BaseService, private router: Router) {}

  ngOnInit() {
    this.lang = this.base.getLang();
  }

  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
  }

  changeLang(lang) {
    localStorage.setItem("lang", lang);
    $(document).ready(function() {
      var body = $("html, body");
      body.stop().animate({ scrollTop: 0 }, 500, "swing");
    });
  }

  home() {
    this.router.navigateByUrl("/");
  }
}
